



















































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import cPopup from "@/components/default/Popup.vue";
import DxRadioGroup from "devextreme-vue/radio-group";
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import notificationService from "@/services/notificationService";
import DxButton from "devextreme-vue/button";
import moment from "moment";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import {
  CreatePlanningAgendaItemCommand,
  DeletePlanningAgendaItemCommand,
  GenerateMeasuringStatePlanningEndDateCommand,
  GetTeamsForPlanningQuery,
  MeasuringStatesClient,
  PlanningAgendaItem,
  PlanningsClient,
  ProjectForPlanningViewModel,
  ProjectsClient,
  StringValueViewModel,
  Team,
  TeamForPlanningDto,
  TeamsClient,
  UpdatePlanningAgendaItemCommand,
} from "@/data/web-api-client";
import Task from "@/classes/Task";
import Project from "@/classes/Project";
import contactsRepository from "@/services/contactsRepository";

@Component({
  components: {
    cPopup,
    DxSimpleItem,
    DxForm,
    DxLabel,
    DxRequiredRule,
    DxItem,
    DxGroupItem,
    DxButton,
    DxRadioGroup,
    DxLoadPanel,
  },
})
export default class AgendaPlanItemAdvancedPopup extends Vue {
  private planningItem: PlanningAgendaItem = new PlanningAgendaItem();
  private teams: TeamForPlanningDto[] = [];
  private show: boolean = false;
  private loading: boolean = false;
  private saving: boolean = false;
  private getEndDate: boolean = false;
  private showSuggenstedStartDate: boolean = true;
  private suggestedEndDate: any;
  private suggestedStartDate: any;

  private mounted() {
    this.getTeams();
  }

  public Open(planningItem: PlanningAgendaItem, startDateProject: Date) {
    this.planningItem = planningItem;
    this.show = true;
    this.getEndDate = false;
    this.suggestedStartDate = startDateProject;
    this.showSuggenstedStartDate = true;
  }

  private Close() {
    this.show = false;
  }

  private reset() {
    this.show = false;
  }

  private async getTeams() {
    this.teams = await new TeamsClient(
      undefined,
      this.$axios
    ).getAllTeamsForPlanning(
      new GetTeamsForPlanningQuery({ workTypes: this.planningItem.workTypes })
    );
  }

  private async save() {
    try {
      const form: any = this.$refs.planningForm;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        if (this.planningItem.teamId) {
          const success = await new PlanningsClient(
            undefined,
            this.$axios
          ).createAgendaItem(
            new CreatePlanningAgendaItemCommand({
              planningAgendaItem: this.planningItem,
              start: this.planningItem.start,
              end: this.planningItem.end,
            })
          );
          if (success) {
            this.Close();
          }
        } else {
          notificationService.showErrorMessage("Geen team geselecteerd.");
        }
      } else {
        notificationService.invalidForm();
      }
    } catch {
      notificationService.failedToSave();
    } finally {
      this.$emit("refresh");
    }
  }

  get worktypesOptions() {
    const catalog = this.$store.getters["catalogs/list"](
      "WorkTypes"
    ) as ICatalogList;
    return { items: catalog ? catalog.values : [] };
  }

  private getPlanningStartDate() {
    if(this.suggestedStartDate != undefined){
      return moment(this.suggestedStartDate).format("DD-MM-YYYY");
    }
    else{
      return null;
    }
  }

  private getPlanningEndDate() {
    if(new Date(this.suggestedEndDate) < new Date(this.suggestedStartDate)){
      this.suggestedEndDate = this.suggestedStartDate;
    }
    return moment(this.suggestedEndDate).format("DD-MM-YYYY");
  }

  private async fieldChanged(event: any) {
    if (event.dataField == "start" || event.dataField == "inclusiveWeekend") {
      this.calculateEndDate();
      this.showSuggenstedStartDate = false;
    } else if (event.dataField == "end") {
      this.getEndDate = false;
    } else if (event.dataField == "workTypes") {
      this.getTeams();
    }
  }

  private async calculateEndDate() {
    if(this.planningItem.start == undefined){
      return;
    }
    this.loading = true;
    this.planningItem.start = new Date(this.planningItem.start!)
    await new MeasuringStatesClient(undefined, this.$axios)
      .calculateEndDateForAgenda(
        new GenerateMeasuringStatePlanningEndDateCommand({
          start: this.planningItem.start,
          measuringStateDocumentNumber:
            this.planningItem.measuringStateDocumentNumber,
          inclusiveWeekend: this.planningItem.inclusiveWeekend,
          teamId: this.planningItem.teamId,
        })
      )
      .then((result) => {
        this.getEndDate = false;
        this.suggestedEndDate = new Date(result);
        this.getEndDate = true;
        this.loading = false;
      });
  }

  private autoFillStartDate() {
    this.planningItem.start = this.suggestedStartDate;
    const form: any = this.$refs.planningForm;
    form.instance.repaint();
    this.showSuggenstedStartDate = false;
    this.calculateEndDate();
  }

  private autoFillEndDate() {
    this.planningItem.end = this.suggestedEndDate;
    const form: any = this.$refs.planningForm;
    form.instance.repaint();
  }
}
